// extracted by mini-css-extract-plugin
module.exports = {"billing_details":"billingHistory_billing_details__2kloK","underlined":"billingHistory_underlined__29Usp","time_badge":"billingHistory_time_badge__3UnJF"};